module.exports = __webpack_public_path__ + "img/super-mario-bros.38e12fc1.png";